"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var _parkingCardOperation = require("../parkingCardOperation");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UnfreezeParkingCardDialog',
  data: function data() {
    var _this = this;
    var checkUnfreezeTime = function checkUnfreezeTime(rule, value, callback) {
      if (!value) {
        callback(new Error('请选择提前解冻时间'));
        return;
      }
      var current = _this.parseTime(value);
      var start = _this.getFreezeStartTime();
      var end = _this.getFreezeEndTime();
      if (current == null || start == null || end == null) {
        callback(new Error('提前解冻时间只能在原冻结时间范围内'));
        return;
      }
      if (current < start || current > end) {
        callback(new Error('提前解冻时间只能在原冻结时间范围内'));
        return;
      }
      callback();
    };
    return {
      visible: false,
      loading: false,
      submitting: false,
      orderNo: '',
      display: {
        productName: '',
        parkName: '',
        plateNo: '',
        statusText: '冻结中',
        freezeTimeText: '',
        freezeStartTime: '',
        freezeEndTime: ''
      },
      form: {
        unfreezeTime: '',
        reason: '',
        attachment: null
      },
      rules: {
        unfreezeTime: [{
          required: true,
          validator: checkUnfreezeTime,
          trigger: 'change'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var start = _this.getFreezeStartTime();
          var end = _this.getFreezeEndTime();
          if (start == null || end == null) return false;
          var dayStart = new Date(time.getFullYear(), time.getMonth(), time.getDate()).getTime();
          var rangeStart = new Date(start);
          rangeStart.setHours(0, 0, 0, 0);
          var rangeEnd = new Date(end);
          rangeEnd.setHours(23, 59, 59, 999);
          return dayStart < rangeStart.getTime() || dayStart > rangeEnd.getTime();
        }
      }
    };
  },
  methods: {
    open: function open(row) {
      var _this2 = this;
      if (!row || !row.orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      this.resetForm();
      this.orderNo = row.orderNo;
      this.visible = true;
      this.fillDisplay(row);
      this.form.unfreezeTime = this.getDefaultUnfreezeTime();
      this.loading = true;
      shopCarOrderApi.getParkingCardOrderDetail(row.orderNo).then(function (res) {
        _this2.fillDisplay(_objectSpread(_objectSpread({}, row), res || {}));
        _this2.form.unfreezeTime = _this2.getDefaultUnfreezeTime();
      }).finally(function () {
        _this2.loading = false;
      });
    },
    fillDisplay: function fillDisplay(data) {
      var freezeRecord = Array.isArray(data.cardOperationRecords) ? data.cardOperationRecords.find(function (item) {
        return Number(item.operationType) === 1;
      }) : null;
      var freezeStart = this.pickFreezeStart(_objectSpread(_objectSpread({}, freezeRecord || {}), data));
      var freezeEnd = this.pickFreezeEnd(_objectSpread(_objectSpread({}, freezeRecord || {}), data));
      this.display = {
        productName: data.productName || '',
        parkName: data.parkName || '',
        plateNo: data.plateNo || '',
        statusText: data.freezeStatusName || data.cardStatusName || '冻结中',
        freezeTimeText: this.formatFreezeRange(freezeStart, freezeEnd),
        freezeStartTime: freezeStart,
        freezeEndTime: freezeEnd
      };
    },
    pickFreezeStart: function pickFreezeStart(data) {
      return data.freezeStartTime || data.freezeStart || data.originalFreezeStartTime || '';
    },
    pickFreezeEnd: function pickFreezeEnd(data) {
      return data.freezeEndTime || data.freezeEnd || data.originalFreezeEndTime || '';
    },
    formatFreezeRange: function formatFreezeRange(start, end) {
      var startText = this.formatDateTime(start, true);
      var endText = this.formatDateTime(end, false);
      if (!startText && !endText) return '';
      return "".concat(startText || '--', " \u81F3 ").concat(endText || '--');
    },
    formatDateTime: function formatDateTime(val, isStart) {
      if (!val) return '';
      var s = String(val).replace('T', ' ');
      if (s.length >= 19) return s.slice(0, 19);
      if (s.length >= 10) {
        return "".concat(s.slice(0, 10), " ").concat(isStart ? '00:00:00' : '23:59:59');
      }
      return s;
    },
    parseTime: function parseTime(val) {
      if (!val) return null;
      var t = new Date(String(val).replace(/-/g, '/').replace('T', ' ')).getTime();
      return Number.isNaN(t) ? null : t;
    },
    getFreezeStartTime: function getFreezeStartTime() {
      var raw = this.formatDateTime(this.display.freezeStartTime, true);
      return this.parseTime(raw);
    },
    getFreezeEndTime: function getFreezeEndTime() {
      var raw = this.formatDateTime(this.display.freezeEndTime, false);
      return this.parseTime(raw);
    },
    pad: function pad(num) {
      return String(num).padStart(2, '0');
    },
    formatNow: function formatNow() {
      var d = new Date();
      return "".concat(d.getFullYear(), "-").concat(this.pad(d.getMonth() + 1), "-").concat(this.pad(d.getDate()), " ").concat(this.pad(d.getHours()), ":").concat(this.pad(d.getMinutes()), ":").concat(this.pad(d.getSeconds()));
    },
    getDefaultUnfreezeTime: function getDefaultUnfreezeTime() {
      var now = Date.now() + 60000;
      var start = this.getFreezeStartTime();
      var end = this.getFreezeEndTime();
      var target = now;
      if (start != null && now < start) target = start;
      if (end != null && now > end) target = end;
      var d = new Date(target);
      return "".concat(d.getFullYear(), "-").concat(this.pad(d.getMonth() + 1), "-").concat(this.pad(d.getDate()), " ").concat(this.pad(d.getHours()), ":").concat(this.pad(d.getMinutes()), ":").concat(this.pad(d.getSeconds()));
    },
    chooseAttachment: function chooseAttachment() {
      var _this3 = this;
      this.$modalUpload(function (items) {
        if (!items || !items[0]) return;
        try {
          _this3.form.attachment = (0, _parkingCardOperation.createOperationAttachment)(items[0]);
        } catch (error) {
          _this3.$message.error(error.message);
        }
      }, '1', 'system', false, {
        maxSizeKB: 1024,
        maxSizeErrorMsg: '附件大小超过1MB，请重新上传~',
        acceptExts: ['jpg', 'png', 'pdf'],
        acceptErrorMsg: '附件格式仅支持JPG、PNG、PDF，请重新上传'
      });
    },
    resetForm: function resetForm() {
      var _this4 = this;
      this.form = {
        unfreezeTime: this.formatNow(),
        reason: '',
        attachment: null
      };
      this.$nextTick(function () {
        _this4.$refs.form && _this4.$refs.form.clearValidate();
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.resetForm();
    },
    handleConfirm: function handleConfirm() {
      var _this5 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (valid) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                if (_this5.form.attachment) {
                  _context.n = 2;
                  break;
                }
                _this5.$message.warning('请上传附件后再确认提前解冻。');
                return _context.a(2);
              case 2:
                _this5.submitting = true;
                _context.p = 3;
                _context.n = 4;
                return shopCarOrderApi.unfreezeParkingCard({
                  orderNo: _this5.orderNo,
                  unfreezeTime: _this5.form.unfreezeTime,
                  reason: _this5.form.reason,
                  attachment: _this5.form.attachment
                });
              case 4:
                _this5.$message.success('提前解冻操作提交成功');
                _this5.$emit('success');
                _this5.handleCancel();
                _context.n = 6;
                break;
              case 5:
                _context.p = 5;
                _t = _context.v;
                if (_t && _t.message === '附件上传失败') _this5.$message.error(_t.message);
              case 6:
                _context.p = 6;
                _this5.submitting = false;
                return _context.f(6);
              case 7:
                return _context.a(2);
            }
          }, _callee, null, [[3, 5, 6, 7]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};